import { Route, Routes } from "react-router-dom";
import { CatalogTundishShroudProvider } from "./context/CatalogTundishShroudContext";
import { CatalogTundishShroudPage } from "./pages/CatalogTundishShroudPage";

type Props = {};
const CatalogTundishShroud = (props: Props) => {
  return (
    <CatalogTundishShroudProvider>
      <Routes>
        <Route index element={<CatalogTundishShroudPage />} />
        <Route path=":tundishShroudId" element={<CatalogTundishShroudPage />} />
      </Routes>
    </CatalogTundishShroudProvider>
  );
};
export default CatalogTundishShroud;
